function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { selector as parseSelector } from 'vega-event-selector';
import { isString } from 'vega-util';
import { TUPLE } from '..';
import { varName } from '../../../util';
import inputBindings from './inputs';
import toggle, { TOGGLE } from './toggle';
var clear = {
  has: function has(selCmpt) {
    return selCmpt.clear !== undefined && selCmpt.clear !== false;
  },
  parse: function parse(model, selCmpt, selDef) {
    if (selDef.clear) {
      selCmpt.clear = isString(selDef.clear) ? parseSelector(selDef.clear, 'scope') : selDef.clear;
    }
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    if (inputBindings.has(selCmpt)) {
      var _iterator = _createForOfIteratorHelper(selCmpt.project.items),
          _step;

      try {
        var _loop = function _loop() {
          var proj = _step.value;
          var idx = signals.findIndex(function (n) {
            return n.name === varName("".concat(selCmpt.name, "_").concat(proj.field));
          });

          if (idx !== -1) {
            signals[idx].on.push({
              events: selCmpt.clear,
              update: 'null'
            });
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    function addClear(idx, update) {
      if (idx !== -1 && _signals[idx].on) {
        _signals[idx].on.push({
          events: selCmpt.clear,
          update: update
        });
      }
    } // Be as minimalist as possible when adding clear triggers to minimize dataflow execution.


    if (selCmpt.type === 'interval') {
      var _iterator2 = _createForOfIteratorHelper(selCmpt.project.items),
          _step2;

      try {
        var _loop2 = function _loop2() {
          var proj = _step2.value;

          var vIdx = _signals.findIndex(function (n) {
            return n.name === proj.signals.visual;
          });

          addClear(vIdx, '[0, 0]');

          if (vIdx === -1) {
            var dIdx = _signals.findIndex(function (n) {
              return n.name === proj.signals.data;
            });

            addClear(dIdx, 'null');
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      var tIdx = _signals.findIndex(function (n) {
        return n.name === selCmpt.name + TUPLE;
      });

      addClear(tIdx, 'null');

      if (toggle.has(selCmpt)) {
        tIdx = _signals.findIndex(function (n) {
          return n.name === selCmpt.name + TOGGLE;
        });
        addClear(tIdx, 'false');
      }
    }

    return _signals;
  }
};
export default clear;